import React, {useState} from 'react'
import { FaIdBadge, FaUser, FaBriefcase, FaBook, FaNewspaper, FaRegFolderOpen , FaEnvelope, FaMusic, FaSignOutAlt } from 'react-icons/fa';
import { FaXmark, FaShop } from "react-icons/fa6";
import { GiHamburgerMenu } from "react-icons/gi";
import { useSelector, useDispatch } from "react-redux";
import { setAccessToken, setRefreshToken } from "../pages/reducer/slices/authSlice"; 
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";

import './Sidebar.css';

const Sidebar = () => {

    const [isOpen, setIsOpen] = useState(false);
    const { accessToken } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Logout function
    const handleLogout = () => {
    dispatch(setAccessToken(null));
    dispatch(setRefreshToken(null));
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    localStorage.removeItem("artId");
    toast.success("Successfully logged out", { position: "top-center" });
    navigate("/login");
    };

    // Sidebar menu items
  const menuItems = [
    { name: "Dashboard", icon: <FaIdBadge />, link: "/ArtistDashboard" },
    { name: "Profile", icon: <FaUser />, link: "/Artist_Profile" },
    { name: "Portfolio", icon: <FaRegFolderOpen />, link: "/portfolioDisplay" },
    { name: "Opportunities", icon: <FaBriefcase />, link: "/Artist_Opportunities" },
    { name: "Application Status", icon: <FaBook />, link: "/statusOfApplication" },
    { name: "Skill Development", icon: <FaMusic />, link: "/CourseCategories" },
    {name: "MarketPlace Dashboard", icon: <FaShop />, link: "/Product_Dashboard"},
    { name: "News", icon: <FaNewspaper />, link: "/latestNews" },
    { name: "Contact Us", icon: <FaEnvelope />, link: "/contactUs" },
    { name: "Logout", icon: <FaSignOutAlt />, action: handleLogout },
  ];
  return (
    <div>
        <aside className="sidebar" style={{width: isOpen ? "250px" : "80px", transition: "width 0.3s"}}>
          <h2 className="sidebar-title" style={{cursor: "pointer", color:"#fff", alignContent:"center"}}>{isOpen ? <p style={{display: "flex", alignItems:"center", justifyContent:"space-between", padding:"0px 10px 0px 20px"}}> Menu <span style={{fontWeight:"600", fontSize:"30px"}}> <FaXmark onClick={()=> setIsOpen(!isOpen)} style={{alignSelf:"end"}} /> </span> </p> : <p onClick={()=> setIsOpen(!isOpen)} style={{display:"flex", justifyContent:"center"}}> <GiHamburgerMenu /> </p>}</h2>
          <ul className="sidebar-menu">
            {menuItems.map((item, i) => (
              <li key={i}>
                {item.action ? (
                  <button className="sidebar-link" style={{justifyContent: isOpen ? "flex-start" : "center", width:"100%"}} onClick={item.action}>
                    <span className="sidebar-icon">{item.icon}</span>
                    {
                        isOpen && (<span className="sidebar-text">{item.name}</span>)
                    }
                  </button>
                ) : (
                  <Link
                    to={item.link}
                    className={`sidebar-link ${
                      location.pathname === item.link ? "active" : ""
                    }`} style={{justifyContent: isOpen ? "flex-start" : "center"}}
                  >
                    <span className="sidebar-icon">{item.icon}</span>
                    {!isOpen && <span className="tooltip">{item.name}</span>}
                    {
                        isOpen && (<span className="sidebar-text">{item.name}</span>)
                    }
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </aside>
    </div>
  )
}

export default Sidebar